import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // ต้องนำเข้า FontAwesomeIcon
import { faMapMarkerAlt, faPhone, faCheckCircle ,faDownload} from '@fortawesome/free-solid-svg-icons';
import { updateOrderStatus } from '../api/airtable'; // ต้องใช้ฟังก์ชันสำหรับการอัปเดตสถานะ
import html2canvas from 'html2canvas';

import '../styles/OrderCard.css'; // นำเข้าฟอนต์และ CSS

const OrderCard = ({ order, username, onOrderUpdate,shouldRemoveOnUpdate }) => {
    const [newStatus, setNewStatus] = useState(order.fields['สถานะ']);
    const [isLoading, setIsLoading] = useState(false); // State สำหรับโหลดแว๊บๆ
    const [showSuccess, setShowSuccess] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false); 
    const [IsRemoving, setIsRemoving] = useState(false); 



   // ตัวเลือกสถานะที่กำหนด
const allStatusOptions = [
    { value: '', label: 'ไม่มีสถานะ' },
    { value: 'จ่ายแล้ว ส่งแล้ว', label: 'จ่ายแล้ว ส่งแล้ว' },
    { value: 'โอนแล้ว ส่งแล้ว', label: 'โอนแล้ว ส่งแล้ว' },
    { value: 'ไม่รับ', label: 'ไม่รับ' },
    { value: 'ไม่ส่ง', label: 'ไม่ส่ง' },
    { value: 'ไม่รับ เลื่อนส่ง', label: 'ไม่รับ เลื่อนส่ง' },
    { value: 'โอนแล้ว รอส่ง', label: 'โอนแล้ว รอส่ง' }
];

// ใช้ฟิลเตอร์เพื่อให้ "โอนแล้ว รอส่ง" แสดงเฉพาะเมื่อสถานะปัจจุบันคือ "โอนแล้ว รอส่ง"
const statusOptions = allStatusOptions.filter(option => {
    return option.value !== 'โอนแล้ว รอส่ง' || newStatus === 'โอนแล้ว รอส่ง';
});
     

    const handleStatusChange = (event) => {
        const selectedStatus = event.target.value;
        setNewStatus(selectedStatus);
        handleUpdateStatus(selectedStatus); // ส่งค่าไปที่ฟังก์ชันอัพเดตสถานะ
    };
    
    const handleUpdateStatus = async (status) => {
        setIsLoading(true); // เริ่มโหลดแว๊บๆ
        setIsUpdating(true);

        try {
            const response = await updateOrderStatus(order.id, status || null, username);
            if (response) {
                setShowSuccess(true);
                setNewStatus(status);

                setTimeout(() => {
                    setIsUpdating(false);
                    setShowSuccess(false);

                    // เงื่อนไขลบการ์ด
                    if (
                        (shouldRemoveOnUpdate && status !== '') || // App.js: ลบถ้า shouldRemoveOnUpdate = true และสถานะไม่ใช่ "ไม่มีสถานะ"
                        (!shouldRemoveOnUpdate && status === '')  // CompletedOrder.js: ลบเฉพาะเมื่อสถานะเป็น "ไม่มีสถานะ"
                    ) {
                        setIsRemoving(true);
                        setTimeout(() => {
                            onOrderUpdate(order.id);
                        }, 500);
                    }
                }, 100);
            } else {
                console.error("ไม่สามารถอัปเดตสถานะได้");
            }
        } catch (error) {
            console.error("Error updating order status:", error);
        }
        setIsLoading(false); // หยุดโหลดแว๊บๆ
        setIsUpdating(false);
    };
    

    const getStatusClass = (status) => {
        if (status === 'โอนแล้ว ส่งแล้ว') {
            return 'status-transfer-completed';
        } else if (status === 'จ่ายแล้ว ส่งแล้ว') {
            return 'status-paid-completed';
        } else {
            return 'status-none';
        }
    };

    const openGoogleMaps = (location) => {
        if (!location || !location[0]) {
            alert("ไม่พบข้อมูลที่ตั้ง");
            return;
        }

        const isCoordinate = /^[0-9.,°'"\sNSEW]+$/;
        let encodedLocation;

        if (isCoordinate.test(location[0])) {
            encodedLocation = encodeURIComponent(location[0]);
        } else {
            encodedLocation = encodeURIComponent(location[0].trim());
        }
        window.open(`https://www.google.com/maps/search/?api=1&query=${encodedLocation}`, '_blank');
    };

    const callPhoneNumber = (phoneNumber) => {
        if (!phoneNumber) {
            alert("ไม่พบข้อมูลเบอร์โทร");
            return;
        }
        window.open(`tel:${phoneNumber}`, '_self');
    };

    const formatCurrency = (number) => {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const customerName = order.fields['ชื่อออเดอร์']
        ? order.fields['ชื่อออเดอร์'].split('-')[0]
        : 'ไม่ระบุ';
    const orderNumber = order.fields && order.fields['เลขที่ออเดอร์'] ? order.fields['เลขที่ออเดอร์'] : 'ไม่ระบุ';

    const status = newStatus || 'ไม่ระบุ';
    const zone = order.fields['โซน'];
    const address = order.fields['จุดรับ'] ? order.fields['จุดรับ'][0] : 'ไม่ระบุ';
    const backupPhoneNumber = order.fields['เบอร์สำรอง'] ? order.fields['เบอร์สำรอง'][0] : 'ไม่มีเบอร์สำรอง';
    const customerContact = order.fields['ชื่อลูกค้า'] || order.fields['ชื่อออเดอร์'].split('-')[0] ;

    const phoneNumber = order.fields['เบอร์โทร'] ? order.fields['เบอร์โทร'][0] : 'ไม่ระบุ';
    const totalAmount = order.fields['รวมเป็นเงิน'] ? `${formatCurrency(order.fields['รวมเป็นเงิน'])} ` : 'ไม่ระบุ';
    const deliveryDate = order.fields['กำหนดส่ง'] || 'ไม่ระบุ';

    const Q = order.fields['ลำดับส่ง'] || '';

    const productList = order.fields['รายการสินค้า']
        ? order.fields['รายการสินค้า'].split('\n').map((item, index) => (
            <li key={index}>
                <input type="checkbox" id={`product-${index}`} />
                <label htmlFor={`product-${index}`}>{item}</label>
            </li>
        ))
        : <li>ไม่มีรายการสินค้า</li>;
        const handleCaptureOrder = () => {
            const element = document.getElementById(`order-inner-${order.id}`);
            html2canvas(element, {
                backgroundColor: '#ffffff', // กำหนดพื้นหลังเป็นสีขาว
                opacity:1,
                scale: 2, // เพิ่มความละเอียดของภาพ
                useCORS: true // อนุญาตการใช้ทรัพยากรข้ามโดเมน
            }).then((canvas) => {
                const link = document.createElement('a');
                link.href = canvas.toDataURL('image/png');
                link.download = `order-${order.id}.png`;
                link.click();
            });
        };
        
    return (
        <div id={`order-${order.id}`} className={`card-column ${IsRemoving ? 'removing-effect' : ''}`}>
            <div id={`order-inner-${order.id}`} className='card-indder'>

            <div className='card-header'>
                {/* ธง "คิว" */}
                <div className="sequence-number">
                    <span className="label">คิว</span>
                    <span className="number">{Q || ''}</span>
                </div>
                <h3>
                    {customerName}
                    <span className="sm">โซน {zone}</span>
                    <span className="sm bg">ออเดอร์# {orderNumber}</span>

                    
                </h3>

                <p>
                    <span>ยอดเงิน </span>
                    {totalAmount}
                </p>
                 {/* เพิ่มเงื่อนไขแสดง "โอนแล้ว รอส่ง" */}
                    {order.fields['สถานะ'] === 'โอนแล้ว รอส่ง' && (
                        <p className="alredyPaid">โอนแล้ว รอส่ง</p>
                    )}
            </div>
            <div className="card-content">
                <p>รายการสินค้า:</p>
                <button className="captureBtn right" onClick={handleCaptureOrder}>
                    <FontAwesomeIcon icon={faDownload} /> 
                </button>
                <ul className="listProduct">
                    
                    {productList}
                </ul>
                <p>ชื่อลูกค้า: {customerContact}</p>
                <p>ที่อยู่: {address}</p>
                <p>เบอร์โทร: {phoneNumber}</p>
                {backupPhoneNumber && backupPhoneNumber.trim() !== '' && backupPhoneNumber !== 'ไม่มีเบอร์สำรอง' ? (
                    <p>เบอร์สำรอง: {backupPhoneNumber}</p>
                ) : null}



                <p>กำหนดส่ง: {deliveryDate}</p>

                <div className={`status-indicator ${getStatusClass(newStatus)}`}>
                    <p><span>สถานะ</span> <span></span></p>
                </div>
               
              
                <select className="status-select" value={newStatus} onChange={handleStatusChange}>
                    {statusOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>


                {showSuccess && (
                    <div className="success-message">
                        <FontAwesomeIcon icon={faCheckCircle} className="check-icon" />
                        <span>อัปเดตเป็น "{newStatus}" สำเร็จแล้ว</span>
                    </div>
                )}


                <div className="button-container">
                    <button onClick={() => openGoogleMaps(order.fields['Location'])}>
                        <FontAwesomeIcon icon={faMapMarkerAlt} /> เปิดแผนที่
                    </button>
                      {/* ปุ่มแคปเจอร์ออเดอร์ */}
                   
                    <button onClick={() => callPhoneNumber(phoneNumber)}>
                        <FontAwesomeIcon icon={faPhone} /> โทรหาลูกค้า
                    </button>
                 
                </div>
            </div>
            {isLoading && <div className="loading-spinner"></div>}

        </div>
        </div>
         
    );
};

export default OrderCard;
